// extracted by mini-css-extract-plugin
export default {"overlayContainer":"styles_overlayContainer__1Edaa","overlayContent":"styles_overlayContent__1Xy3n","fadeIn":"styles_fadeIn__DAC3f"};